import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import staff from '../../assets/staff.svg';
import message from '../../assets/message.svg';

const ErrorContainerStaff = () => {
  const goToMember = () => {
    window.location = 'https://www.aeromexicorewards.com/mx/bienvenido/';
  };

  return (
    <Container className="bg-white">
      <Row className="pb-60 py-sm-60">
        <Col lg={9} className="text-center mt-30">
          <h2 className="mb-15 text-tangaroa">¡Lo sentimos!</h2>
          <h3>Te recordamos que los empleados de Aeroméxico Rewards no pueden participar en</h3>
          <h3 className="mb-15">Subastas Rewards.</h3>
          <img src={staff} alt="error-img" className="mt-30" />
          <h4 className="mb-30 text-boulder-light">Haz clic en el botón para ir al sitio web de Aeroméxico Rewards.</h4>
          <button type="button" className="btn btn-primary mb-15" id="sbs-dsb-dgr-btn-mor" onClick={goToMember}>
            Salir
          </button>
        </Col>
        <Col lg={3} className="">
          <div className="bg-alabaster p-3 br-1 d-none d-sm-block">
            <img src={message} alt="invoice-img" />
            <h4 className="mt-15 text-tangaroa">Importante</h4>
            <h5 className="mt-15">No realizaste ninguna puja.</h5>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorContainerStaff;
